import {
    onBeforeUnmount,
    computed,
    isRef,
    toValue,
    watch,
} from 'vue';

const CONFIG = {
    attributes: true,
    childList: true,
    subtree: true,
    characterData: false,
    attributeOldValue: false,
    characterDataOldValue: false,
    attributeFilter: [],
};

export function useMutationObserver(element, callback, options = {}) {
    const config = {...CONFIG, ...options};
    let observer = undefined;

    const computedTarget = computed(() => {
        if (!element) return undefined;

        return isRef(element) ? toValue(element) : element;
    });

    const stopWatch = watch(
        () => computedTarget.value,
        (target) => {
            cleanup();

            if (
                window 
                && 'MutationObserver' in window 
                && target 
                && typeof callback === 'function'
            ) {
                observer = new MutationObserver(callback);
                observer.observe(target, config);
            }
        },
        {
            immediate: true,
            flush: 'post',
        },
    );

    function cleanup() {
        if (observer) {
            observer.disconnect();
            observer = undefined;
        }
    }

    function takeRecords() {
        return observer?.takeRecords();
    }

    function reset() {
        stopWatch();
        cleanup();
    }
    
    onBeforeUnmount(reset);

    return {
        reset,
        takeRecords,
    };
}
